import { render } from "./AdminWallet.vue?vue&type=template&id=b04b76a2"
import script from "./AdminWallet.vue?vue&type=script&lang=js"
export * from "./AdminWallet.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__